import { Button } from '@/shared/ui/button';
import { ArrowLeft } from 'lucide-react';

interface BackButtonProps {
  handleBackToList: () => void;
}

const BackButton = ({ handleBackToList }: BackButtonProps) => {
  return (
    <Button
      variant="outline"
      size="lg"
      onClick={handleBackToList}
      className="flex items-center space-x-2 px-4 py-2 md:px-4 md:py-2 rounded-lg shadow-sm hover:shadow-md active:shadow-inner touch-manipulation"
    >
      <ArrowLeft className="h-4 w-4" />
      <span className="hidden md:inline">Back</span>
    </Button>
  );
};

export default BackButton;
